import * as TK from 'components/search/Profile/translations/constants';
import { Translations } from 'translations/types';

export const profileEnUsLocale: Translations = {
  [TK.PROFILE_VISIT_SITE]: 'visit site',
};
